import styled, { keyframes } from 'styled-components';
import { Modal, Input, Drawer } from 'antd';
import { BLACK, GREY_12, GREY_2, GREY_7, LIGHT_PRIMARY, PRIMARY } from '../../utils/colors';

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 56px;
  margin-bottom: 30px;
  padding-left: 67px;
  padding-right: 67px;

  @media (max-width: 768px) {
    margin-top: 0px;
    padding-left: 24px;
    padding-right: 24px;
  }
`;

export const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 40px;
    overflow: hidden;
  }
`;

export const StyledInput = styled(Input)`
  border: 1px solid ${GREY_12};
   
  border-radius: 24px;
  height: 48px;
  
  
  &:focus, &:focus-within, &:hover {
    border: 1px solid ${PRIMARY};
    background-color: #fff;
    box-shadow: none;
  }
`;

export const ErrorMessage = styled.p`
  color: #e53e3e;
  font-size: 12px;
  margin-top: 4px !important;

  &.centered{
    text-align: center;
  }
`

export const DrawerHandle = styled.span`
  position: absolute;
  display: block;
  width: 40px;
  height: 4px;
  border-radius: 9999px;
  background-color: #D4D2CE;
  left: 0px;
  right: 0px;
  top: 0px;
  margin: 0 auto;
`;

export const AuthDrawerStyle = styled(Drawer)`
  .ant-drawer-content {
    border-top-left-radius: 24px !important;
    border-top-right-radius: 24px !important;
  }
  .ant-drawer-header-title {
    position: relative;
    padding-top: 12px;
  }
  .ant-drawer-close { 
    svg {
      color: #434455;
      size: 24px;
    }
  }
`;

export const LogoContainer = styled.div`
  margin-bottom: 40px;

  @media (max-width: 768px) {
    margin-top: 10px;
  }
`;

export const Title = styled.h2`
  font-size: 24px;
  font-weight: 600;
  color: ${BLACK};
  margin-bottom: 32px;
`;

export const SocialButton = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 12px;
  background: ${GREY_12};
  border: none;
  border-radius: 50px;
  padding: 14px;
  font-size: 16px;
  font-weight: 500;
  color: ${BLACK};
  cursor: pointer;
  transition: all 0.2s;
  position: relative;

  &:hover {
    background: #e5e7eb;
  }
`;

export const DividerContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin: 20px 0;
  color: #9CA3AF;
  font-size: 14px;
  font-weight: 500;

  &::before,
  &::after {
    content: '';
    flex: 1;
    border-bottom: 1px solid ${GREY_7};
  }

  span {
    padding: 0 16px;
  }
`;

export const FormContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const InputLabel = styled.label`
  font-size: 14px;
  color: #4B5563;
  margin-bottom: 10px;
  font-weight: 500;
`;

export const DisclaimerText = styled.p`
  font-size: 14px;
  color: #5D5D5D;
  margin-top: 0px;
  margin-bottom: 24px;
`;

export const SubmitButton = styled.button`
  width: 100%;
  background: ${PRIMARY};
  color: white;
  border: none;
  border-radius: 50px;
  padding: 16px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  margin-bottom: 30px;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.9;
  }
`;

export const TermsText = styled.p`
  font-size: 14px;
  color: #434455;
  text-align: center;
  line-height: 1.5;
  margin-bottom: 0px;
  a {
    color: ${PRIMARY} !important;
    text-decoration: underline !important;
  }
`;

export const TermsLink = styled.a`
  color: ${PRIMARY};
  text-decoration: underline !important;
`

export const OTPContainer = styled.div`
  margin-bottom: 10px;
  width: 100%;
`;

export const OtpInput = styled.input`  
  &:focus {
    outline: none;
    border-color: ${PRIMARY} !important;
  }
`;

export const OtpError = styled.p`
  font-size: 13px;
  color: #ef4444;
  text-align: left;
  margin-bottom: 3px;
`;

export const ResendText = styled.p`
  font-size: 14px;
  color: #4B5563;
  text-align: left;
  width: 100%;
  padding-left: 4px;
`;

export const ResendTextButton = styled.button`
  font-size: 14px;
  color: ${PRIMARY};
  cursor: pointer;
  background: none;
  padding: 0;
  border: none;
  padding-left: 4px;

  &:hover {
    opacity: 0.9;
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const OtpContainer = styled.div`
  position: relative;
`

export const LoadingOtpContainer = styled.div`
  position: absolute;
  inset: 0;
  background-color: rgba(255, 255, 255, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(12px);
`

export const LastLoginText = styled.div`
  position: absolute;
  top: -12px;
  right: 12px;
  background: color-mix(in srgb, ${PRIMARY} 12%, white);
  color: ${PRIMARY};
  font-size: 12px;
  font-weight: 500;
  padding: 2px 8px;
  border-radius: 12px;
  border: 1px solid ${PRIMARY};
`

// ─── animation ───────────────────────────────────────────────────────────────
const spin = keyframes`
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
`;

// ─── types ───────────────────────────────────────────────────────────────────
type SpinnerProps = {
  size?: number;
  variant?: 'gold' | 'white';
};

// ─── component ───────────────────────────────────────────────────────────────
export const Spinner = styled.div<SpinnerProps>`
  width:  ${({ size = 32 }) => size}px;
  height: ${({ size = 32 }) => size}px;
  border-radius: 50%;
  margin: 0 auto;

  border: 2px solid
    ${({ variant = 'gold' }) =>
      variant === 'white'
        ? '#ffffff4D'
        : `${PRIMARY}4D`};

  border-top-color:
    ${({ variant = 'gold' }) =>
      variant === 'white' ? '#ffffff' : PRIMARY};

  animation: ${spin} 0.75s linear infinite;
`;
